






















































































































import { Component, Vue } from "vue-property-decorator";

import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";

@Component
export default class TestResult extends Vue {
  private service = new GeneralService();
  private id = localStorage[config.classLevl];
  private title: any = "";
  private testSubjectData: any = [];
  private selectedSubjectData: any = [];
  private courseNames: any = [];
  private selected: any = [];
  private selectedCorrect: any = [];
  private answers = ["A", "B", "C", "D"];
  private answersE = ["A", "B", "C", "D", "E"];
  private totalCorrect = 0;
  private totalIncorrect = 0;
  private totalQuestions = 0;
  private isM: any = false;

  mounted() {
    if (this.$route?.query.workDayId && this.$route?.query.title) {
      const { workDayId, title } = this.$route?.query;
      this.title = title;

      this.service.getQuestionsWA(workDayId, title).then((response) => {
        this.courseNames = [];
        this.testSubjectData = this.orderMcqs(response);
        for (let i = 0; i < this.testSubjectData.length; i++) {
          this.courseNames.push(this.testSubjectData[i].courseName);
          this.selected[this.testSubjectData[i].courseName] = [];
          this.selectedCorrect[this.testSubjectData[i].courseName] = [];
        }
        this.selectedSubjectData = this.testSubjectData[0];
        this.populateTest(this.testSubjectData);
      });
    }

    if (
      localStorage[config.isM] &&
      localStorage[config.isM] !== undefined &&
      JSON.parse(localStorage[config.isM]) == true
    ) {
      this.isM = true;
    }
  }

  private orderMcqs(data) {
    let orderedMcqs: any = [];
    if (data) {
      for (let i = 0; i < data.length; i++) {
        orderedMcqs[data[i].orderNo - 1] = data[i];
      }

      return orderedMcqs;
    }

    return data;
  }

  private goHome() {
    router.push("/step-learning");
  }

  private getCourseData(subject: string) {
    for (let i = 0; i < this.testSubjectData.length; i++) {
      if (this.testSubjectData[i].courseName === subject) {
        return this.testSubjectData[i];
      }
    }
  }

  private changeSubject(subject: string) {
    this.selectedSubjectData = this.getCourseData(subject);
  }

  private populateTest(data: any) {
    for (let h = 0; h < data.length; h++) {
      for (let i = 0; i < data[h].mcqs.length; i++) {
        this.totalQuestions++;
        for (let j = 0; j < data[h].answerInput?.length; j++) {
          if (
            data[h].mcqs[i].questionTxt ===
            data[h].answerInput[j].question
          ) {
            if (!data[h].answerInput[j].isReview) {
              this.selected[data[h].courseName][i] =
                data[h].answerInput[j].answerValue;
              if (data[h].answerInput[j].answerValue ===
                JSON.parse(data[h].mcqs[i].answer)[0]
                  .correctAnswer){
                this.selectedCorrect[data[h].courseName][i] = true;
                this.totalCorrect++;
              } else {
                this.selectedCorrect[data[h].courseName][i] = false;
                this.totalIncorrect++;
              }
            }
          }
        }
      }
    }
  }
}
